<template lang="pug">
div
	h4.tw-font-bold.tw-mb-4(ref="titleEl" v-show="source != 'postSale'") {{$t('sale.customize_solution.other_offers', 'Altre offerte')}}
	v-progress-circular(:indeterminate='true' v-if='loading' color='primary')
	.tw-flex.tw-flex-col.tw-gap-4(v-if='travelSolutionView && travelSolutionView.offers_map')
		customize-train(
			v-for='train in travelSolutionView.trains'
			:key='train.id'
			:travellers="travelSolutionView.offers_map[train.id] && travelSolutionView.offers_map[train.id].travellers"
			:train="train"
			:services-map="servicesMap"
		)
	div(v-if='travelSolutionView && !travelSolutionView.offers_map && !loading')
		p {{$t('sale.customize_solution.error', 'Si è verificato un errore durante il recupero delle offerte')}}
		v-btn(v-if='isDev' @click="fetchOffersMapCalled=false;fetchOffersMap()") {{$t('common.retry', 'Riprova')}}
</template>

<script setup>
import { useBookingStore } from '@/stores/booking';
import { inject, shallowRef, watch, ref, triggerRef, onMounted, provide, onActivated, computed} from 'vue';
import CustomizeTrain from './customize-train.vue';
import {useI18n} from "vue-i18n";
import { usePostSaleStore } from '@/stores/post-sale';


const postSale = usePostSaleStore();
const booking = useBookingStore();
const props = defineProps({
	travelSolution: Object
});
const i18n = useI18n();
const servicesMap = shallowRef(null);
const axios = inject('axios');
const loading = ref(false);
const titleEl = ref();
const {fetchForCustomizeOffers, initCustomizedOffers, travelSolutionView} = inject('travelSolutionSelection');

const isDev = import.meta.env.DEV;
let fetchOffersMapCalled = false;

const emit = defineEmits(['update:travel-solution'])
provide('solution', travelSolutionView);
const source = inject('source', null);

async function fetchOffersMap(){
	if(fetchOffersMapCalled) return;

	if(travelSolutionView.value && travelSolutionView.value.offers_map){
		initCustomizedOffers();
		return;
	}

	loading.value = true;
	fetchOffersMapCalled = true;
	await fetchForCustomizeOffers()
	.then(() => {
		emit('update:travel-solution', travelSolutionView.value);
	})
	.catch(e => {
		console.error(e);
	}).then(() => {
		loading.value = false;
	});
}

onMounted(() => {
	fetchOffersMap();
});

onActivated(() => {
	if(titleEl.value){
		titleEl.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}
	fetchOffersMap();
});
</script>